import React from "react";
import { ToDateJalali } from "../../../../Common/Function";

function ClassInfo({ classData }) {
  return (
    <div className="row detailsclass p-0 justify-content-between">
      <div className="col-12 col-md-5 p-0 ">
        <div
          id="carouselExampleControls"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner">
            {classData &&
              classData.images.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={`carousel-item ${i === 0 ? "active" : ""}`}
                  >
                    <img
                      className="d-block w-100 sliderorderclass"
                      src={item}
                      alt={"calss" + i}
                      height={"210px"}
                      width={"400px"}
                    />
                  </div>
                );
              })}
          </div>
          <a
            className="carousel-control-prev"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            />
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
      <div className="col-12  col-md-6 ">
        <div className="d-flex flex-column p-3">
          <div className=" align-items-center text-center">
            <h5 style={{ color: "black", fontWeight: "400" }}>
              کلاس {classData.type == "online" ? "غیر حضوری" : "حضوری"}{" "}
              {classData.name}
            </h5>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span style={{ color: "black", fontWeight: "400" }}>
              تاریخ شروع کلاس :
            </span>
            <span
              style={{
                marginRight: "5px",
                color: "black",
                fontWeight: "400",
              }}
            >
              {ToDateJalali(classData.start_date)}
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span style={{ color: "black", fontWeight: "400" }}>
              {" "}
              مهلت ثبت نام :
            </span>
            <span
              style={{
                marginRight: "5px",
                color: "black",
                fontWeight: "400",
              }}
            >
              {ToDateJalali(classData.exp_register)}
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span style={{ color: "black", fontWeight: "400" }}>
              {" "}
              تعداد جلسات :
            </span>
            <span
              style={{
                marginRight: "5px",
                color: "black",
                fontWeight: "400",
              }}
            >
              {classData.count_session} جلسه
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span style={{ color: "black", fontWeight: "400" }}>
              {" "}
              ظرفیت :
            </span>
            <span
              style={{
                marginRight: "5px",
                color: "black",
                fontWeight: "400",
              }}
            >
              {classData.capacity} نفر
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span style={{ color: "black", fontWeight: "400" }}>
              {" "}
              آدرس برگزار کننده :
            </span>
            <span
              style={{
                marginRight: "5px",
                color: "black",
                fontWeight: "400",
              }}
            >
              {classData.organizer_details.address}{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClassInfo;